<template>
  <b-modal
    :id="'schedule-document-modal'"
    :cancel-title="$t('Cancel')"
    centered
    no-close-on-backdrop
    :ok-title="$t('ScheduleDocumentButton')"
    size="xs"
    @close="emitCloseModal"
    @submit.stop.prevent="generateDocument">
    <template #modal-header="{ close }">
      <div class="modalHeader">
        <div>
          <h5 class="modal-title mb-0">{{ $t('ScheduleDocumentButton') }} : {{ paiement.name }}</h5>
        </div>
      </div>
    </template>

    <div>
      <b-form ref="formSchedule" @submit.stop.prevent="generateDocument">

        <div class="bold-text level-two-title my-2 main-red-color">
          {{ $t('scheduleDocument.acheteurSection.title') }}
        </div>

        <b-form-group
          :invalid-feedback="form.acheteur.invalidFeedback"
          :label="$t('scheduleDocument.acheteurSection.name') "
          :state="form.acheteur.state"
          class="medium-label mb-4"
          label-for="acheteur-input">
          <b-form-input
            id="acheteur-input"
            v-model="form.acheteur.value"
            v-disable-scroll
            required
            type="text">
          </b-form-input>
        </b-form-group>

        <b-form-group
          :invalid-feedback="form.adresse.invalidFeedback"
          :label="$t('scheduleDocument.acheteurSection.address') "
          :state="form.adresse.state"
          class="medium-label mb-4"
          label-for="adresse-input">
          <b-form-input
            id="adresse-input"
            v-model="form.adresse.value"
            v-disable-scroll
            required
            type="text">
          </b-form-input>
        </b-form-group>

        <div class="bold-text level-two-title my-2 main-red-color">
          {{ $t('scheduleDocument.bankSection.title' , {societe : this.$store.getters.entreprise}) }}
        </div>

        <b-form-group
          :invalid-feedback="form.iban.invalidFeedback"
          :label="$t('scheduleDocument.bankSection.iban') "
          :state="form.iban.state"
          class="medium-label mb-4"
          label-for="iban-input">
          <b-form-input
            id="iban-input"
            v-model="form.iban.value"
            v-disable-scroll
            required
            type="text">
          </b-form-input>
        </b-form-group>

        <b-form-group
          :invalid-feedback="form.bic.invalidFeedback"
          :label="$t('scheduleDocument.bankSection.bic')"
          :state="form.bic.state"
          class="medium-label mb-4"
          label-for="bic-input">
          <b-form-input
            id="bic-input"
            v-model="form.bic.value"
            v-disable-scroll
            required
            type="text">
          </b-form-input>
        </b-form-group>
      </b-form>
    </div>

    <template #modal-footer>
      <b-button
        variant="secondary"
        v-show="!isLoading"
        @click="hideModal">
        {{ $t('Cancel') }}
      </b-button>

      <b-button
        :class="{ 'loading-ellipsis': isLoading }"
        :disabled="isLoading"
        variant="primary"
        @click="generateDocument('pdf')">
        {{ isLoading ? $t('Generating...') : $t('GeneratePDF') }}
      </b-button>

      <b-button
        :class="{ 'loading-ellipsis': isLoading }"
        :disabled="isLoading"
        variant="primary"
        @click="generateDocument('word')">
        {{ isLoading ? $t('Generating...') : $t('GenerateWord') }}
      </b-button>
    </template>

  </b-modal>
</template>

<script>
import api from '../../../services/api'
import i18n from "../../../i18n";

export default {
  name: 'ScheduleDocumentModal',

  props: {
    paiement: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      form: {
        acheteur:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        adresse:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        iban :
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        bic :
          {
            state: null,
            invalidFeedback: null,
            value: null,
          }
      },
      errorOccurred: false,
      isLoading: false
    }
  },

  methods: {

    emitCloseModal() {
      this.errorOccurred = false
      this.$emit("didCloseModal")
    },

    resetModal() {
      if (!this.errorOccurred) {
        this.form.acheteur.value = null
        this.form.adresse.value = null
        this.form.iban.value = null
        this.form.bic.value = null
      }
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    async generateDocument(type, $event) {
      const form = this.$refs.formSchedule;

      if ($event && typeof $event.preventDefault === "function") {
        $event.preventDefault();
      }

      if (!form.reportValidity()) {
        this.errorOccurred = true;
        return;
      }

      this.isLoading = true;

      const data = new FormData();
      data.append("paiementId", this.paiement.id);
      data.append("acheteur", this.form.acheteur.value);
      data.append("adresse", this.form.adresse.value);
      data.append("iban", this.form.iban.value);
      data.append("bic", this.form.bic.value);
      data.append("format", type);

      let url = `/operation/generateScheduleDoc`;

      try {
        const response = await api({
          method: "POST",
          url: url,
          data: data,
          responseType: "blob"
        });

        const extension = type === "pdf" ? "pdf" : "docx";
        const mimeType =
          type === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

        const blob = new Blob([response.data], { type: mimeType });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const today = new Date().toISOString().slice(0,10)
        link.download = `appel_fonds_${this.paiement.percentage || ''}_${this.paiement.name}_${today}.${extension}`
          .replace(/\s+/g, '_')
          .replace(/[^\w\-\.]/g, '');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.successToast();
        this.errorOccurred = false;
        this.resetModal();
        this.hideModal();
      } catch (error) {
        console.error(error);
        this.errorOccurred = true;
        if (error.response && error.response.status === 403) {
          const invalidField = error.response.data.invalidField;
          this.form[invalidField].state = false;
          this.form[invalidField].invalidFeedback = i18n.t(error.response.data.message);
        }
      } finally {
        this.isLoading = false;
      }
    },


    hideModal() {
      this.$bvModal.hide('schedule-document-modal')
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('scheduleDocument.success'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationSchedule/ScheduleDocumentModal.vue